import { getHealthPlanName} from './Utils'
export function getInsuranceAndBilling(props) {
    const { hasMyChart, epicEHRDown, bundle, isProxyUser, aalDown, hasAAL, hasHealthPlanLogin, isMemberPayer, swhpDown
        , isActiveFeature_InsuranceModule, hasFirstCare, swhp, insuranceTabText, dentalInvoice, hpIdentity
        , isEmployee, enablePricingTransparency, currentPharmacyUser
        , isMedicalAdvice, bffDashboardData, currentUser, enableCareCompanion, thriveData, isMyChartInActive } = props;
    const pathname = typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "";
    const isPharmacy = bundle === "pharmacy" || pathname.indexOf('/pharmacy') === 0;
    const isMyBSWHealth = bundle === "mybswhealth" && !isPharmacy;
    const notPharmacyProxy = isMyBSWHealth || isPharmacy && !currentPharmacyUser;
    const isMyChartProxyUser = isProxyUser;
    const healthPlanName = getHealthPlanName(props);
    const showDental = (swhp && dentalInvoice);


    const memberId = swhp || (hpIdentity && hpIdentity.memberUserClaims && hpIdentity.memberUserClaims.memberHccId);
    const auntBerthaLink = 'https://bswhealthplan.auntbertha.com/';

    const payPremiumUrl = /HIM/g.test(memberId)
        ? 'https://firstcare.softheon.com/account/payments/locate-account'
        : /BSW/g.test(memberId)
            ? 'https://bsw.softheon.com/account/payments/locate-account'
            : null;
    const showHPInvoicesandPayments = (hasHealthPlanLogin && isMemberPayer)
        || (hpIdentity && !payPremiumUrl && (hpIdentity.roles.includes("CobraMembers")
        || hpIdentity.roles.includes("InvoicePaymentSsoUsers")
        || hpIdentity.roles.includes("IndividualMedicareMembers")));

    const showTaxForms = !(hpIdentity && hpIdentity.memberUserClaims &&
        (hpIdentity.memberUserClaims.businessLineNames.includes("Medicare")
            || hpIdentity.memberUserClaims.businessLineNames.includes("CHIP")
            || hpIdentity.memberUserClaims.businessLineNames.includes("Medicaid")
            || hpIdentity.memberUserClaims.businessLineNames.includes("Self Funded")
        ));
    const showWellnessPage = (swhp && !isEmployee) || ((hpIdentity && !hpIdentity.roles.includes("MedicareMembers") &&
        !hpIdentity.roles.includes("ChipMembers") && !hpIdentity.roles.includes("MedicaidMembers")));

    const showVirtualCare = hpIdentity && hpIdentity.roles.includes("TelemedicineSsoUsers") && !swhp;
    const showCostEstimator = swhp || (hpIdentity && hpIdentity.roles.includes("ActiveMembers")
        && hpIdentity.memberUserClaims
        && !(hpIdentity.memberUserClaims.businessLineNames.includes("Medicaid")
            || hpIdentity.memberUserClaims.businessLineNames.includes("Self Funded")));

    const isActiveHRMember = swhp || (hpIdentity && hpIdentity.roles.includes("ActiveMembers"));
    return {
        icon: "icon-ins",
        show: (notPharmacyProxy && (hasMyChart || (isActiveFeature_InsuranceModule && notPharmacyProxy && !isMyChartProxyUser))),
        disabled: (((hasMyChart && epicEHRDown) || !hasMyChart || isMyChartInActive) && ((hasAAL && !isMyChartProxyUser && aalDown) || !hasAAL) && ((!hasAAL && hasHealthPlanLogin && !isMyChartProxyUser && swhpDown) || !hasHealthPlanLogin)) && (!hasFirstCare),
        navHead: {
            label: "Insurance & Bill Pay",
            url: null
        },
        navItems: [
            {
                label: healthPlanName,
                //show: notPharmacyProxy && hasAAL && !isMyChartProxyUser,
                show: isActiveFeature_InsuranceModule && notPharmacyProxy && !isMyChartProxyUser,
                url: null,
                disabled: (aalDown && hasAAL) || (swhpDown && hasHealthPlanLogin) || isMyChartInActive,
                subMenuItems: {
                    menuLabel: healthPlanName,
                    menuItems: [
                        {
                            label: 'Claims',
                            show: true,
                            //show: notPharmacyProxy && hasAAL && !isMyChartProxyUser,
                            url: '/claims'
                        },
                        {
                            label: 'Authorizations',
                            show: (!hasAAL && hasHealthPlanLogin && !swhp) || hasFirstCare,
                            url: '/authorizations'
                        },
                        {
                            label: insuranceTabText,
                            show: true,
                            //show: notPharmacyProxy && hasAAL && !isMyChartProxyUser,
                            url: '/usage'
                        },
                        {
                            label: hasAAL ? 'Plan' : 'Plan Benefits',
                            show: true,
                            //show: notPharmacyProxy && hasAAL && !isMyChartProxyUser,
                            url: '/benefits'
                        },
                        {
                            label: 'ID Card',
                            show: true,
                            //show: notPharmacyProxy && hasAAL && !isMyChartProxyUser,
                            url: '/idcard',
                            altUrls: ['/requestnewidcard']
                        },
                        {
                            label: 'Dental',
                            show: showDental, //false
                            url: '/dental'
                        },
                        {
                            label: 'Invoices & Payments',
                            show: !hasAAL && showHPInvoicesandPayments,
                            url: '/invoicesAndPayments'
                        },
                        {
                            label: 'Tax Forms',
                            show: showTaxForms,
                            url: '/taxforms'
                        },
                        {
                            label: 'Documents and Resources',
                            show: !hasAAL,
                            url: '/documents'
                        },
                        {
                            label: 'Member Support',
                            show: !hasAAL,
                            url: '/support',
                            altUrls: ['/newsupportrequest']
                        },
                        {
                            label: 'Other Coverage',
                            show: !hasAAL,
                            url: '/otherCoverage'
                        },
                        {
                            label: 'Payment Options',
                            show: false,
                            url: '/paymentOptions'
                        },
                        //{
                        //    label: 'Other Coverage',
                        //    show: !hasAAL,
                        //    url: null
                        //},
                        {
                            label: 'Wellness',
                            show: notPharmacyProxy && !hasAAL && !isMyChartProxyUser && showWellnessPage,
                            url: '/wellness',
                        },
                        {
                            label: 'Virtual Care',
                            show: showVirtualCare,
                            url: '/virtualCare',
                        },
                        {
                            label: 'Cost Estimator',
                            show: showCostEstimator,
                            url: '/costEstimator',
                        }
                    ]
                }
            },
            {
                label: 'Bill Pay',
                show: notPharmacyProxy && hasMyChart,
                url: '/accountsummary',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Insurances on File',
                show: notPharmacyProxy && hasMyChart,
                url: '/insurance',
                altUrls: ['/coverage'],
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Estimates',
                show: enablePricingTransparency && hasMyChart,
                url: '/estimates/myEstimates',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Insurance Premium Due',
                show: isActiveFeature_InsuranceModule && !hasAAL && showHPInvoicesandPayments,
                url: '/invoicesAndPayments',
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive
            },
            {
                label: 'Pay My Premium',
                show: isActiveFeature_InsuranceModule && payPremiumUrl,
                url: payPremiumUrl,
                subMenuItems: null,
                target: '_blank'
            },
            {
                label: 'Connect to Local Resources',
                show: isActiveHRMember && isActiveFeature_InsuranceModule && !isEmployee,
                url: auntBerthaLink,
                subMenuItems: null,
                target: '_blank'
            },
        ]
    };
}